import { PayloadAction } from '@reduxjs/toolkit';
import { call, select } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { selectMessageEntity } from 'features/chat/chatSlice';
import { ChatImageDeletedPayload, ChatMessage } from 'features/chat/types';

export function* deleteImageSaga(action: PayloadAction<ChatImageDeletedPayload>) {
  const { messageId, id } = action.payload;
  const message: ChatMessage | undefined = yield select(selectMessageEntity, messageId);
  if (!message) {
    return;
  }

  const isLastImageWithoutText = !message.message?.trim() && message.images?.length === 1;

  if (isLastImageWithoutText) {
    yield call(SignalingSocket.send, { event: 'deleteChatMessage', data: { id: messageId } });
  } else {
    yield call(SignalingSocket.send, {
      event: 'deleteChatImage',
      data: { messageId, imageId: id },
    });
  }
}
